export const font = [
	'Inter',
	'-apple-system',
	'"Segoe UI"',
	'"Helvetica Neue"',
	'sans-serif',
].join(',');

export default {
	fontFamily: font,
	body3: {
		fontSize: '19px',
		letterSpacing: '0.1px',
		lineHeight: 1.2,
	},
	button: {
		fontWeight: 700,
	},
	h1: {
		fontWeight: 700,
	},
	h2: {
		fontWeight: 700,
	},
	h3: {
		fontWeight: 600,
	},
	h4: {
		fontWeight: 500,
	},
	h5: {
		fontWeight: 600,
	},
	overline: {
		fontSize: '16px',
	},
	subtitle1: {
		fontWeight: 500,
	},
};
